
<mat-dialog-content style="min-width:100%;">
  <div class="col-xs-12 no-padder full-width-typeahead">
    <input class="form-control input-lg" type="text" placeholder="Search Catalog" aria-label="Number" name="catalog" autocomplete="off" matInput="matInput" style="border-radius:30px" [formControl]="autoCompleteController" [matAutocomplete]="auto"/>
    <mat-autocomplete class="search-bar-xs" #auto="matAutocomplete">
      <mat-option *ngFor="let option of options | async" [value]="option.name" (onSelectionChange)="autoCompleteOnSelect(option)">{{option.name}}</mat-option>
    </mat-autocomplete>
  </div>
</mat-dialog-content>